import {combineReducers} from 'redux';
import common from './common';
import message from './message';
import gdCallReduxState from './gdcall';

export default combineReducers({
    common,
    message,
    gdCallReduxState
});
